import { render } from "./musicPlayer.vue?vue&type=template&id=33c925e7&scoped=true"
import script from "./musicPlayer.vue?vue&type=script&lang=js"
export * from "./musicPlayer.vue?vue&type=script&lang=js"

import "./musicPlayer.vue?vue&type=style&index=0&id=33c925e7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c925e7"]])

export default __exports__